module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('vheader'), _c('mobile-nav'), _c('div', {
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("观察员申请")]), _vm._m(0), _c('div', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_vm._v("立即申请"), _c('div', {
    staticClass: "triangle-right"
  })])])])]), _vm._m(1), _vm._m(2)]), _c('footer-user'), _c('vfooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "observer-tip"
  }, [_c('p', [_vm._v("「前沿社」作为邀请参与制及闭门交流为主的社群，"), _c('br'), _vm._v("并不只是个神秘封闭的小圈子，"), _c('br'), _vm._v("同样愿意把有价值的思考分享给更多希望持续思考、刷新认知的伙伴。")]), _c('p', [_vm._v("如果您尚未具备成为会员的资质，"), _c('br'), _vm._v("即刻可以加入成为「前沿社观察员」。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container min"
  }, [_c('div', {
    staticClass: "entry-subhead"
  }, [_c('h3', [_vm._v("OBSERVER BENEFITS")]), _c('h3', {
    staticClass: "cn"
  }, [_vm._v("观察员权益")])]), _c('div', {
    staticClass: "entry-list"
  }, [_c('ul', [_c('li', [_vm._v("全年至少6次前沿社「前沿工作坊」现场参与资格，以最效率的方式搞懂前沿技术；")]), _c('li', [_vm._v("极客公园年度两个重磅活动「奇点创新者峰会Rebuild」、「极客公园创新大会IF」VIP参会资格，以及受邀参加前沿社「夏季会晤」、「冬季会晤」至少8场闭门论坛，与中国最优秀的创业者共同探讨前沿的科技趋势、与全球最权威的专家面对面沟通，价值20000元；")]), _c('li', [_vm._v("还有机会获得前沿社纯闭门学习交流「近场研究」外卡嘉宾机会，具体参加场次视申请人所处行业领域和当次活动主题而定；")]), _c('li', [_vm._v("第一时间获取「前沿工作坊」、「近场研究」以及前沿社其他相关活动的精彩内容；")]), _c('li', [_vm._v("优先有机会参与「前沿社」组织的闭门海外游学团，与优秀企业家一同拓展视野、升级认知。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container min"
  }, [_c('div', {
    staticClass: "entry-subhead"
  }, [_c('h3', [_vm._v("CONDITIONS OF ENTRY")]), _c('h3', {
    staticClass: "cn"
  }, [_vm._v("申请条件")])]), _c('div', {
    staticClass: "entry-list special"
  }, [_c('ul', [_c('li', [_c('b', [_vm._v("申　请：")]), _vm._v("申请人通过在线提交申请、完成付款后，即可享受前沿社观察员权益")]), _c('li', [_c('b', [_vm._v("会员费：")]), _vm._v("9,999元/人/年")])])]), _c('div', {
    staticClass: "entry-list about"
  }, [_c('p', [_vm._v("通过以下方式可申请成为观察员："), _c('br'), _vm._v("1.找到一位前沿社会员作为您的推荐人"), _c('br'), _vm._v("2.在线填写前沿观察员申请表格"), _c('br'), _vm._v("3.完成付款流程后，即可开启「前沿社观察员」的交流学习旅程")]), _c('p', [_vm._v("注："), _c('br'), _vm._v("1.前沿社观察员有效期为一年，有效期为自付款成功之日起至次年的同一时间为止；"), _c('br'), _vm._v("2.如未能找到前沿社会员作为推荐人，请在申请表格上详细说明申请理由。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e1791e4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Observer.vue
// module id = 188
// module chunks = 1